export default class BaseComponent extends HTMLElement {
  #el = null

  static get is() { return 'base' }

  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.#el = document.createElement(this.rootEl)
    if (this.styles) this.shadowRoot.innerHTML = `<style>${this.styles}</style>`
    this.shadowRoot.appendChild(this.#el)
  }

  get rootEl() { return 'span' }

  get params() {
    return ((this.textContent || '').trim().split(':') || []).map(s => s.trim())
  }

  set componentText(value) {
    this.#el.textContent = value
  }

  set componentHtml(value) {
    this.#el.innerHTML = value
  }

  setComponentAttribute(name, value) {
    this.#el.setAttribute(name, value)
  }

  connectedCallback() { 
    if (typeof this.mounted === 'function') {
      this.mounted()
    }
    this.updated() 
  }

  disconnectedCallback() {
    if (typeof this.unmounted === 'function') {
      this.unmounted()
    }
  }

  updated() {
    throw new Error('updated method must be implemented in subclass')
  }
}
